import { render } from "./PreguntaView.vue?vue&type=template&id=0f61f584"
import script from "./PreguntaView.vue?vue&type=script&lang=js"
export * from "./PreguntaView.vue?vue&type=script&lang=js"

import "./PreguntaView.vue?vue&type=style&index=0&id=0f61f584&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__